import { useReducer } from 'react';

const UPDATE_FILTERS = 'UPDATE_FILTERS';
const LOAD_MORE = 'LOAD_MORE';

export const updateFiltersAction = (payload) => ({
  type: UPDATE_FILTERS,
  payload,
});
export const loadMoreAction = () => ({ type: LOAD_MORE });

export default function useFiltersReducer(initialState) {
  const reducer = (state, action) => {
    if (action.type === UPDATE_FILTERS) {
      return {
        ...action.payload,
        page: 1,
      };
    }

    if (action.type === LOAD_MORE) {
      return {
        ...state,
        page: state.page + 1,
      };
    }

    return state;
  };

  const initializer = (initialState) => initialState;

  return useReducer(reducer, initialState, initializer);
}
